import React from "react";
import {
  MDBCol,
  MDBRow,
  MDBInput,
  MDBModal,
  MDBNavLink,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBDataTable,
  MDBListGroup,
  MDBListGroupItem,
  MDBContainer,
  MDBInputGroup,
  MDBBtn,
} from "mdbreact";
import "./invoices-view.css";
import Alert from "sweetalert2";
import { colors } from "../../theme";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { Redirect, Link } from "react-router-dom";
import SpinnerView from "../../components/spinner/spinner-view";
import DateFilter from "../../components/DateFilter";
import DownloadLink from "react-download-link";
import urls from "../../network/urls";
import { Pie } from "react-chartjs-2";
import moment from "moment";
import Invoice from "../../components/invoice";
import Breadcrumb from "../../components/breadcrumb";
import { format } from "../../helpers/invoiceNumber";

class HomeView extends React.Component {
  state = {
    modal: false,
    pdfModal: false,
    newInvoice: {},
    newLineItem: {},
    rankType: "all",
    showAdd: false,
    selected: [],
    search: "",
  };

  handleChange = (value, prop) => {
    var t = this.state.newInvoice;
    t[prop] = value;
    this.setState({
      newInvoice: t,
    });
  };

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({
      newLineItem: t,
    });
  };

  handleSearch = (value) => {
    console.log(value);
    this.setState({
      search: value,
    });
  };

  togglePDF = () => {
    this.setState({
      pdfModal: !this.state.pdfModal,
    });
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      newInvoice: {},
    });
  };

  addLineItem = () => {
    this.setState({
      newInvoice: {
        ...this.state.newInvoice,
        descriptions: this.state.newInvoice.descriptions
          ? [
              ...this.state.newInvoice.descriptions,
              { ...this.state.newLineItem },
            ]
          : [{ ...this.state.newLineItem }],
      },
    });
  };

  deleteLineItem = (desc) => {
    this.setState({
      newInvoice: {
        ...this.state.newInvoice,
        descriptions: this.state.newInvoice.descriptions.filter(
          (item) => item.description != desc
        ),
      },
    });
  };

  edit = (invoice) => {
    this.setState({
      modal: !this.state.modal,
      newInvoice: invoice,
    });
  };

  handleClick = (event, name) => {
    const selectedIndex = this.state.selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.state.selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.state.selected.slice(1));
    } else if (selectedIndex === this.state.selected.length - 1) {
      newSelected = newSelected.concat(this.state.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.selected.slice(0, selectedIndex),
        this.state.selected.slice(selectedIndex + 1)
      );
    }

    this.setState({
      selected: newSelected,
    });
  };

  handleSelectAll = (onlyUnSent) => {
    let newSelected = this.props.invoices.invoices
      .filter((i) => !i.isQuote && !i.paid && (onlyUnSent ? !i.sent : true))
      .map((i) => i._id);

    this.setState({
      selected: newSelected,
    });
  };

  componentDidMount() {
    this.props.dispatchGetInvoices();
  }

  componentDidUpdate(prevProps, prevState) {
    // Add/remove body class for scrolling when invoice view is shown
    if (this.state.showAdd !== prevState.showAdd) {
      if (this.state.showAdd) {
        document.body.classList.add("invoice-view-active");
      } else {
        document.body.classList.remove("invoice-view-active");
      }
    }
  }

  componentWillUnmount() {
    // Clean up body class when component unmounts
    document.body.classList.remove("invoice-view-active");
  }

  createInvoice = () => {
    this.props.createInvoice(this.state.newInvoice);
    this.setState({
      modal: !this.state.modal,
      newInvoice: "",
    });
  };

  setRank = (rank) => {
    this.setState({
      rankType: rank,
    });
  };

  scrollToTop = () => window.scrollTo(0, 0);

  getDataFromURL = (url, user, process) =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        let req = {
          headers: {
            username: user.username,
            token: user.token,
            AUTHORIZATION: user.token,
          },
          method: "GET",
        };

        fetch(url, req)
          .then((response) => response.blob())
          .then((data) => {
            resolve(data);
            if (process) this.props.dispatchGetInvoices();
          });
      });
    }, 2000);

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd });
  };

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to="/" />;
    }

    let all = 0;
    let paid = 0;
    let un = 0;
    let quote = 0;
    let unTotal = 0;
    let paidTotal = 0;
    let quoteTotal = 0;

    var Invoices = [];

    let methodPaids = {};
    const isSelected = (name) => this.state.selected.indexOf(name) !== -1;

    if (this.props.invoices.invoices.length > 0) {
      Invoices = this.props.invoices.invoices.map((p, index) => {
        if (!methodPaids[p.methodPaid]) methodPaids[p.methodPaid] = 0;

        let total = 0;
        let preTotal = 0;
        let discount = 0;

        if (p.descriptions) {
          p.descriptions.map((i) => {
            let qty = i.qty ?? 1;
            preTotal += parseFloat(i.price) * parseFloat(qty);
          });

          if (p.discount && p.discount.hasDiscount) {
            if (p.discount.discountType == "Amount")
              discount = -1 * parseFloat(p.discount.discountValue);
            else
              discount =
                -1 * ((preTotal / 100) * parseFloat(p.discount.discountValue));
          }
          total = preTotal + discount;
          methodPaids[p.methodPaid] += total;

          all += 1;
          if (!!p.isQuote) {
            quote += 1;
            quoteTotal += total;
          } else {
            if (!!!p.paid) {
              un += 1;
              unTotal += total;
            }
            if (!!p.paid) {
              paid += 1;
              paidTotal += total;
            }
          }
        }
        const isItemSelected = isSelected(p._id);
        const labelId = `enhanced-table-checkbox-${index}`;

        let diff = !p.paid ? (
          moment().diff(moment(p.dueDate), "days") > 0 ? (
            <span className="right badge badge-danger">
              {moment().diff(moment(p.dueDate), "days")}
              {" days overdue"}
            </span>
          ) : (
            <span className="right badge badge-warning">
              {moment().diff(moment(p.dueDate), "days")}
              {" days left"}
            </span>
          )
        ) : (
          ""
        );

        if (!!p.queuedForSending && !p.queuedForSendingError) {
          diff = (
            <>
              <span className="right badge badge-warning">{"Sending..."}</span>
              {diff}
            </>
          );
        }
        if (!!p.queuedForSendingError) {
          diff = (
            <>
              <span className="right badge badge-danger">
                {p.queuedForSendingError}
              </span>
              {diff}
            </>
          );
        }

        let sent = (
          <>
            {p.sent ? moment(p.sent).format("YYYY-MM-DD") : ""}
            {p.emails ? (
              <span className="right badge badge-info ml-1">
                {p.emails.length}
                {" times"}
              </span>
            ) : (
              ""
            )}
          </>
        );

        return {
          name: p.client
            ? p.client.name + " " + (p.client.surname ? p.client.surname : "")
            : p.to,
          invoiceDate: moment(p.invoiceDate).format("YYYY-MM-DD"),
          diff,
          dueDate: !!p.dueDate ? moment(p.dueDate).format("YYYY-MM-DD") : "",
          invoiceNumber: (
            <span>
              {!!p.isQuote && (
                <span className="right badge badge-warning">quote</span>
              )}
              {!!p.paid && !p.isQuote && (
                <span className="right badge badge-success">paid</span>
              )}
              {!p.paid && !p.isQuote && (
                <span className="right badge badge-danger">un-paid</span>
              )}{" "}
              {p.invoiceNumber}
            </span>
          ),
          rank: p.rank,
          iNumber: p.invoiceNumber,
          sent,
          paid: p.paid,
          total: "R " + format(total),
          totalA: total,
          isQuote: p.isQuote,
          method: p.methodPaid,
          select: (
            <input
              type="checkbox"
              id={labelId}
              checked={isItemSelected}
              onClick={(event) => this.handleClick(event, p._id)}
            />
          ),
          view: (
            <MDBContainer>
              <button
                type="button"
                className="btn btn-sm btn-info"
                onClick={() => {
                  this.props.getInvoice(p._id, loaded);
                  this.props.selectInvoice(p._id);
                  let updateshowAdd = this.updateshowAdd;
                  function loaded(error) {
                    if (!error) updateshowAdd(true);
                  }
                }}
              >
                View
              </button>
              <DownloadLink
                label="Download"
                className="btn btn-primary btn-sm ml-2"
                style={{
                  margin: 0,
                  textDecoration: "none",
                  color: "white",
                  cursor: "pointer",
                }}
                filename={"invoice_" + p.invoiceDate + ".pdf"}
                exportFile={() =>
                  Promise.resolve(
                    this.getDataFromURL(
                      urls.getInvoices(this.props.selectedCompanyId) +
                        "/" +
                        p._id +
                        "/download",
                      this.props.authUser
                    )
                  )
                }
              ></DownloadLink>
            </MDBContainer>
          ),
        };
      });
    }

    var dataPie = {
      labels: Object.keys(methodPaids),
      datasets: [
        {
          data: Object.keys(methodPaids).map((i) => methodPaids[i]),
          backgroundColor: [
            "#F7464A",
            "#46BFBD",
            "#FDB45C",
            "#949FB1",
            "#4D5360",
            "#AC64AD",
          ],
          hoverBackgroundColor: [
            "#FF5A5E",
            "#5AD3D1",
            "#FFC870",
            "#A8B3C5",
            "#616774",
            "#DA92DB",
          ],
        },
      ],
    };

    const data = {
      columns: [
        {
          label: "",
          field: "select",
          sort: "asc",
        },
        {
          label: "Invoice Date",
          field: "invoiceDate",
          sort: "asc",
        },
        {
          label: "Sent",
          field: "sent",
          sort: "asc",
        },
        {
          label: "Status",
          field: "diff",
          sort: "asc",
        },
        {
          label: "Invoice #",
          field: "invoiceNumber",
          sort: "asc",
          searchable: true,
        },
        {
          label: "Amount",
          field: "total",
          sort: "asc",
        },
        {
          label: "Payment",
          field: "method",
          sort: "asc",
        },
        {
          label: "Client",
          field: "name",
          sort: "asc",
          searchable: true,
        },
        {
          label: "",
          field: "view",
          sort: "asc",
        },
      ],
      rows: Invoices.filter((i) => {
        if (this.state.rankType == "all") return true;
        else if (this.state.rankType == "paid") return !!i.paid && !i.isQuote;
        else if (this.state.rankType == "quote") return !!i.isQuote;
        else if (this.state.rankType == "unpaid")
          return !!!i.paid && !i.isQuote;
      })
        .filter((i) => {
          if (this.state.search == "") return true;
          else
            return (
              i.name.toLowerCase().includes(this.state.search.toLowerCase()) ||
              i.iNumber.toLowerCase().includes(this.state.search.toLowerCase())
            );
        })
        .sort(function (a, b) {
          if (a.invoiceDate < b.invoiceDate) return 1;
          else return -1;
        }),
    };

    return (
      <div className="content-wrapper p-2">
        <SpinnerView showSpinner={this.props.invoices.loading} />

        {this.state.showAdd && (
          <div className="invoice-view-container">
            <Invoice
              showAdd={this.state.showAdd}
              updateshowAdd={this.updateshowAdd}
            />
          </div>
        )}

        {/* Page Header */}
        {!this.state.showAdd && (
          <div className="page-header">
            <h1 className="page-title">
              <i className="fas fa-file-invoice-dollar"></i>
              Invoices
            </h1>
          </div>
        )}

        {!this.state.showAdd && (
          <DateFilter action={this.props.dispatchGetInvoices} />
        )}

        {/* Unified Toolbar */}
        {!this.state.showAdd && (
          <div className="invoice-toolbar invoice-actions-desktop">
            {/* New Button */}
            <button
              className="invoice-toolbar-btn primary"
              onClick={() => {
                this.props.dispatchClearInvoice();
                this.updateshowAdd(true);
              }}
            >
              <i className="fas fa-plus"></i>
              New Invoice
            </button>

            {/* Recurring Link */}
            <Link className="invoice-toolbar-btn secondary" to="/recurring?type=invoices">
              <i className="fas fa-sync-alt"></i>
              Recurring
            </Link>

            <div className="invoice-toolbar-divider"></div>

            {/* Filter Buttons */}
            <div className="invoice-toolbar-group">
              <button
                className={`invoice-toolbar-btn filter ${this.state.rankType === 'all' ? 'active' : ''}`}
                onClick={() => this.setRank('all')}
              >
                All
                <span className="toolbar-badge">{all}</span>
              </button>
              <button
                className={`invoice-toolbar-btn filter ${this.state.rankType === 'paid' ? 'active' : ''}`}
                onClick={() => this.setRank('paid')}
              >
                Paid
                <span className="toolbar-badge">{paid}</span>
              </button>
              <button
                className={`invoice-toolbar-btn filter ${this.state.rankType === 'unpaid' ? 'active' : ''}`}
                onClick={() => this.setRank('unpaid')}
              >
                Unpaid
                <span className="toolbar-badge">{un}</span>
              </button>
              <button
                className={`invoice-toolbar-btn filter ${this.state.rankType === 'quote' ? 'active' : ''}`}
                onClick={() => this.setRank('quote')}
              >
                Quotes
                <span className="toolbar-badge">{quote}</span>
              </button>
            </div>

            <div className="invoice-toolbar-divider"></div>

            {/* Export Button */}
            <DownloadLink
              label={<><i className="fas fa-file-export"></i> Export CSV</>}
              className="invoice-toolbar-btn export"
              style={{ textDecoration: 'none' }}
              filename={"sage_import.csv"}
              exportFile={() => {
                return Alert.fire({
                  title: "Process the current period unpaid invoices as paid. Do you want to continue?",
                  showDenyButton: true,
                  confirmButtonColor: colors.primary,
                  cancelButtonColor: colors.action,
                  showCancelButton: false,
                  confirmButtonText: "Continue",
                  denyButtonText: `Cancel`,
                }).then((result1) => {
                  if (result1.isConfirmed) {
                    return Alert.fire({
                      title: "Do you want to mark all invoices as resolved to sage?",
                      showDenyButton: true,
                      confirmButtonColor: colors.primary,
                      cancelButtonColor: colors.action,
                      showCancelButton: false,
                      confirmButtonText: "Resolve all",
                      denyButtonText: `Just download`,
                    }).then((result) => {
                      let url = urls.getInvoices(this.props.selectedCompanyId) + "/export";
                      if (result.isConfirmed) {
                        url = urls.getInvoices(this.props.selectedCompanyId) + "/process";
                      }
                      if (this.props.global) {
                        url = url + "?from=" + this.props.global.dateFrom.format("YYYY-MM-DD");
                        url = url + "&to=" + this.props.global.dateTo.format("YYYY-MM-DD");
                        url = url + "&type=" + this.props.global.dateIndex;
                        return Promise.resolve(
                          this.getDataFromURL(url, this.props.authUser, result.isConfirmed)
                        );
                      }
                    });
                  } else {
                    return "canceled";
                  }
                });
              }}
            />
          </div>
        )}

        {!this.state.showAdd && this.state.rankType == "paid" && (
          <div className="card card-danger smallpie">
            <div className="card-header">
              <h3 className="card-title">Payment Methods</h3>

              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i className="fas fa-minus"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="chartjs-size-monitor">
                <div className="chartjs-size-monitor-expand">
                  <div className=""></div>
                </div>
                <div className="chartjs-size-monitor-shrink">
                  <div className=""></div>
                </div>
              </div>
              <Pie
                data={dataPie}
                className={"pieChart"}
                options={{ responsive: true }}
              />
            </div>
          </div>
        )}

        {/* Unified Content Card */}
        {!this.state.showAdd && (
          <div className="invoice-content-card invoice-actions-desktop">
            {/* Stats Row */}
            <div className="invoice-stats-row">
              <div className="invoice-stat-item paid">
                <div className="invoice-stat-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="invoice-stat-content">
                  <span className="invoice-stat-label">Paid</span>
                  <span className="invoice-stat-value">R {format(paidTotal)}</span>
                </div>
              </div>
              <div className="invoice-stat-item outstanding">
                <div className="invoice-stat-icon">
                  <i className="fas fa-exclamation-circle"></i>
                </div>
                <div className="invoice-stat-content">
                  <span className="invoice-stat-label">Outstanding</span>
                  <span className="invoice-stat-value">R {format(unTotal)}</span>
                </div>
              </div>
              <div className="invoice-stat-item quotes">
                <div className="invoice-stat-icon">
                  <i className="fas fa-file-alt"></i>
                </div>
                <div className="invoice-stat-content">
                  <span className="invoice-stat-label">Quotes</span>
                  <span className="invoice-stat-value">R {format(quoteTotal)}</span>
                </div>
              </div>
            </div>

            {/* Desktop Table View */}
            <div className="invoice-table-desktop">
              <MDBDataTable
                disableRetreatAfterSorting={true}
                striped
                bordered
                small
                data={data}
                onSearch={this.handleSearch}
              />
            </div>

            {/* Selection Buttons */}
            <div className="invoice-selection-buttons">
              <button
                type="button"
                className="btn btn-sm btn-info"
                onClick={() => {
                  this.handleSelectAll(true);
                }}
              >
                Select Not Paid Unsent
              </button>
              <button
                type="button"
                className="btn btn-sm btn-info"
                onClick={() => {
                  this.handleSelectAll();
                }}
              >
                Select All Not Paid
              </button>
              {this.state.selected.length > 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-info"
                  onClick={() => {
                    this.setState({
                      selected: [],
                    });
                  }}
                >
                  Clear {this.state.selected.length} Selected
                </button>
              )}
              {this.state.selected.length > 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => {
                    let t = this;
                    Alert.fire({
                      title: "Are you sure you want to send the selected invoices?",
                      showDenyButton: true,
                      showCancelButton: false,
                      confirmButtonText: "Yes",
                      denyButtonText: `No`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        function doneSent(response) {
                          if (response.message == "Enqueued") {
                            Alert.fire(
                              "Your invoices was queued to be sent, please refresh your invoices after a few minutes"
                            );
                            t.setState({
                              selected: [],
                            });
                          } else {
                            Alert.fire(
                              "There has been an error with queueing, please try again later or contact support if this happens again."
                            );
                          }
                        }
                        this.props.sendBulkInvoices(this.state.selected, doneSent);
                      } else if (result.isDenied) {
                      }
                    });
                  }}
                >
                  Send {this.state.selected.length} Selected
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
/*
    descriptions:[{
        name:"name",
        "price":100
    }],
    */
export default HomeView;
